import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext.tsx';
import { serviceFactory } from '@/services/core/serviceFactory.ts';
import { PatientEnrollerService } from '@/services/features/PatientEnrollerService.ts';

export const usePEClinicIds = () => {
  const { user, hasuraToken } = useAuth();
  const [clinicIds, setClinicIds] = useState<number[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Get service instance
  const patientEnrollerService = serviceFactory.getService(PatientEnrollerService);

  useEffect(() => {
    fetchClinicIds();
  }, [user?.id, hasuraToken]);

  const fetchClinicIds = async () => {
    if (!user?.id || !hasuraToken) return;

    console.log('usePEClinicIds - fetchClinicIds called for user:', user.id);
    console.log('usePEClinicIds - hasuraToken available:', !!hasuraToken);

    try {
      setIsLoading(true);
      setError(null);

      const response = await patientEnrollerService.fetchClinicIds(parseInt(user.id));

      console.log('usePEClinicIds - API Response success:', response.success);
      console.log('usePEClinicIds - API Response:', response);

      if (response.success && response.data?.pep_patient_enroller_active_assignments) {
        const assignments = response.data.pep_patient_enroller_active_assignments;
        
        // Process clinic IDs using service method
        const processedClinicIds = patientEnrollerService.processClinicIds(assignments);
        
        console.log('usePEClinicIds - Setting clinic IDs:', processedClinicIds);
        setClinicIds(processedClinicIds);
      } else {
        console.error('usePEClinicIds - Failed to fetch clinic IDs:', response.errors);
        throw new Error('Failed to fetch clinic IDs from API');
      }
    } catch (err) {
      console.error('Error fetching clinic IDs:', err);
      setError(err instanceof Error ? err.message : 'Unknown error');
      // Fallback to default clinic ID if error
      setClinicIds([2]);
    } finally {
      setIsLoading(false);
    }
  };

  return { clinicIds, isLoading, error, refetch: fetchClinicIds };
};